function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.425 20.945h-3.83v-9.033H7.68V8.799h1.915V6.93c0-2.54 1.08-4.05 4.151-4.05h2.557v3.114h-1.598c-1.196 0-1.275.435-1.275 1.247l-.005 1.558h2.895l-.339 3.113h-2.556v9.033z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.1e203070.svg";
export { SvgComponent as ReactComponent };